import { Injectable } from '@angular/core';

@Injectable()
export class CatalogoService {

  constructor() { }

  public getCatalogoPeriodos() {;
    let periodos = [];

    periodos.push({id: 1, descripcion: "SEMANAL"});
    periodos.push({id: 2, descripcion: "QUINCENAL"});
    periodos.push({id: 3, descripcion: "MENSUAL", default: true});
    periodos.push({id: 4, descripcion: "BIMESTRAL"});
    periodos.push({id: 5, descripcion: "TRIMESTRAL"});
    periodos.push({id: 6, descripcion: "SEMESTRAL"});
    periodos.push({id: 7, descripcion: "ANUAL"});

    return periodos;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/tools/catalogos.service.ts